module.exports = __webpack_public_path__ + "img/light.3b6726db.png";